import React from "react";

export const TriangleDown = ({ ...props }) => (
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.5 19L0.674683 0.25L22.3253 0.25L11.5 19Z" />
  </svg>
);
